import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { takeUntil } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { injectDestroy } from 'ngxtension/inject-destroy';
import { DateHelperService } from '../../services/date-helper.service';
import { InfoTooltipComponent } from '../info-tooltip.component';

@Component({
  selector: 'formly-field-availability',
  template: `
    <div>
      <h3 class="mb-2 gap-1">
        {{ props.label }}
        <app-info-tooltip [tooltip]="props.info"></app-info-tooltip>
      </h3>
      <div class="block">
        @for (field of field.fieldGroup; track $index) {
          <formly-field [field]="field" [class]="field.className"></formly-field>
        }
      </div>
      @if (field.props.description) {
        <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
      }
    </div>
  `,
  imports: [
    ReactiveFormsModule,
    MatAutocompleteModule,
    FormlyModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    InfoTooltipComponent,
  ],
  styles: `
    ::ng-deep #top .checkbox-flex mat-checkbox {
      width: 100% !important;
    }

    ::ng-deep mat-mdc-form-field-subscript-wrapper {
      position: relative;
      bottom: 10px;
    }

    ::ng-deep .mat-form-field-disabled.mat-mdc-form-field {
      flex-direction: row !important;
      mat-hint {
        position: relative;
        bottom: 4px;
        line-height: 1;
        text-align: left;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldAvailability extends FieldType implements OnInit {
  private destroy$ = injectDestroy();
  constructor() {
    super();
  }

  ngOnInit() {
    this.field.formControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      const weeklyhours = this.field.formControl.get('weeklyHours')?.value;

      if (weeklyhours != undefined && weeklyhours > 36) {
        const days = {
          maandag: { enabled: true },
          dinsdag: { enabled: true },
          woensdag: { enabled: true },
          donderdag: { enabled: true },
          vrijdag: { enabled: true },
          zaterdag: { enabled: false },
          zondag: { enabled: false },
        };

        ['availabilityOdd', 'availabilityEven'].forEach(availabilityType => {
          const availability = this.field.formControl.get(availabilityType);

          // check if days are already
          if (availability?.value && !Object.values(availability.value).some(day => day['enabled'])) {
            availability.patchValue(days);
          }
        });
      }

      ['availabilityOdd', 'availabilityEven'].forEach(availabilityType => {
        const availability = this.field.formControl.get(availabilityType);
        const availabilityTotalHours = this.field.formControl.get(availabilityType + 'TotalHours');

        // update odd/even total hours
        let totalHours = 0;
        if (availability?.value) {
          Object.values(availability?.value).forEach(day => {
            if (day['enabled'] && day['start'] && day['end']) {
              totalHours +=
                DateHelperService.timeStringToFloat(day['end']) - DateHelperService.timeStringToFloat(day['start']);
            } else if (day['enabled']) {
              totalHours += 24;
            }
          });
          if (availabilityTotalHours !== undefined && availabilityTotalHours !== null) {
            availabilityTotalHours.patchValue((Math.round(totalHours * 100) / 100).toFixed(2), {
              emitEvent: false,
            });
          }
        }
      });
    });
  }
}
